module.exports = __webpack_public_path__ + "img/babylying.c6f46531.svg";